import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useLang } from "../i18n";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="border-t" style={{ borderColor: "#E5E2DC", background: "#F3F1EC" }}>
      <div className="px-6 sm:px-12 lg:px-20 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div className="space-y-4">
          <Logo />
          <p className="font-mono-meta text-xs uppercase tracking-[0.2em] text-[#8C8983]">{t("footer.book")}</p>
        </div>
        <div>
          <p className="font-mono-meta text-xs uppercase tracking-[0.2em] text-[#8C8983] mb-5">{t("footer.nav")}</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link to="/oeuvres" className="link-line w-fit" data-testid="footer-works-link">{t("nav.works")}</Link>
            <Link to="/presentation" className="link-line w-fit" data-testid="footer-presentation-link">{t("nav.presentation")}</Link>
            <Link to="/contact" className="link-line w-fit" data-testid="footer-contact-link">{t("nav.contact")}</Link>
          </div>
        </div>
        <div>
          <p className="font-mono-meta text-xs uppercase tracking-[0.2em] text-[#8C8983] mb-5">{t("footer.contact")}</p>
          <div className="flex flex-col gap-3 text-sm">
            <a href="mailto:max.dhumerelle@gmail.com" className="link-line w-fit" data-testid="footer-email-link">
              max.dhumerelle@gmail.com
            </a>
            <a
              href="https://instagram.com/Max.dhum"
              target="_blank"
              rel="noreferrer"
              className="link-line w-fit"
              data-testid="footer-instagram-link"
            >
              @max.dhum
            </a>
          </div>
        </div>
      </div>
      <div className="px-6 sm:px-12 lg:px-20 pb-8 flex flex-col sm:flex-row justify-between gap-3 font-mono-meta text-[11px] uppercase tracking-[0.18em] text-[#8C8983]">
        <span>© 2026 Max Dhum — {t("footer.rights")}</span>
        <span>Toulouse, France</span>
      </div>
    </footer>
  );
}
